module.exports = __webpack_public_path__ + "media/video.34046513.mp4";